import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import _, { replace } from "lodash";
import { useNavigate } from "react-router-dom";
// Import custom SVG icon for Administrator navigation item
import { ReactComponent as Administrator } from "../../../assets/nav-admin.svg";

//utils
import { getIconName, setLocalStorageFlag, getLocalStorageFlag } from "../../../utils/common";
import { getCookie } from "../../../serviceWorker";
import { routeURLs } from "../../../utils/enums";

import { useI18n } from "../../../i18n/useI18n";

//component
import { isAnalyticsPage } from "../../../utils/common";
import { onSingleMenuClick, onMenuClick } from "../../../utils/common";
import BetaTag from "../../../common/BetaTag";

const Menu = ({ navItem, onClick, isSingleMenuItem, setAltoProps }) => {
    const { tGenerics } = useI18n('generics');
    const [
        HbrIcon,
        HbrMenu,
        HbrNavItem,
        HbrMenuItem,
        HbrMenuLabel
    ] = reactWrapper([
        "hbr-icon",
        "hbr-menu",
        "hbr-nav-item",
        "hbr-menu-item",
        "hbr-menu-label"
    ]);
    const clVmanageURI = getCookie("cl-analytics");
    const navigate = useNavigate();
    const isChecked = !_.isEmpty(navItem.path) && location.pathname.includes(navItem.path);
    const isBandwidthForecastingTab =
        location.pathname === routeURLs.bwf ||
        getLocalStorageFlag("bandForecastingTab") === "true";

    if ((!('submenu' in navItem))) {
        //use case for single menu like Explore (vManage) or Reports (vAnalytics) menu
        // Explore menu does not have submenu in mega menu json
        //use case for version 18.2 and greater
        const navigateTo = () => {
            onSingleMenuClick(navItem, clVmanageURI);
        }
        return <HbrNavItem collapsed value={navItem.text} className="nav-item-section" onClick={navigateTo}>
            <HbrIcon slot="prefix" name={`nav-${navItem.icon}`} />
            <div slot="content">{navItem.text}</div>
        </HbrNavItem>
    }

    let MenuItemsComponent = [];
    let isvManagePath = clVmanageURI ? true : false;

    const handleMenuClick = (menu, isvManagePath = false, isvAnalyticsPath = false, event) => {
        const label = event?.currentTarget?.getAttribute('aria-label') ||
            event?.currentTarget?.querySelector('div[slot="content"]')?.textContent.trim();

        if (label === 'SD-WAN Manager') {
            // case for cross launch
            onClick(event);

        } else if (isvManagePath && !isvAnalyticsPath) {

            //case for converge ui
            if (menu.submenu.url) {
                //check if the submenu has type convergence with dynamic menu
                let vAnalyticsPath = menu.submenu.url;
                if (menu.submenu?.type === "convergence") {
                    if (menu.submenu.i18nKey.includes("bandwidth")) {
                        // Special case for Bandwidth Forecasting Tab
                        setLocalStorageFlag("bandForecastingTab", true);
                        setAltoProps({ predictiveTabSelected: "bandForecastingTab", status: "" });
                        vAnalyticsPath = routeURLs.bwf;
                    } else if (menu.submenu.i18nKey.includes("anomaly")) {
                        // Special case for Anomaly Detection Tab
                        setLocalStorageFlag("bandForecastingTab", false);
                        setAltoProps({ predictiveTabSelected: "anomalyTab", status: "" });
                    } else {
                        // Special case for PPR Tab
                        setLocalStorageFlag("bandForecastingTab", false);
                        setAltoProps({ predictiveTabSelected: "pprTab", status: "" });
                    }
                }

                //redirect to the url of vAnalytics
                navigate(vAnalyticsPath)
            } else {
                //redirect to the path of vManage
                onMenuClick(menu.path, clVmanageURI);
            }

        } else {
            //case for non converge ui and cross launch
            navigate(menu.path);
        }
    }

    if (navItem.submenu) {
        const submenu = navItem.submenu;
        const submenuComponent = [];
        let isHeaderLabelFound = false;

        if (navItem.submenu.length === 1) {
            const path = isvManagePath ? `/#/app/${navItem.text.toLowerCase()}` : navItem.path;

            //menu with single submenu, like Explore (vManage) or Reports (vAnalytics) menu
            MenuItemsComponent = (
                <HbrMenu shellNav>
                    <HbrMenuItem
                        shellNav
                        value={submenu[0].text}
                        checked={isChecked}
                        checkMark
                        onClick={(e) => handleMenuClick({ path: path, submenu: [] }, isvManagePath, false, e)}
                        key={Math.random()}
                    >
                        {submenu[0].text}
                    </HbrMenuItem>
                </HbrMenu>)
        } else {
            //menu with multiple submenus, like Workflow or Anlytics menu
            for (let submenuIndex = 0; submenuIndex < submenu.length; submenuIndex++) {
                const sectionIndex = submenuIndex;

                //submenus with header sections
                if (submenu[submenuIndex].headerLabel) {
                    isHeaderLabelFound = true;

                    //create a menu section with header
                    submenuComponent.push(<HbrMenuLabel key={Math.random()} shellNav className="section-heading">{submenu[sectionIndex].text}</HbrMenuLabel>)

                    for (let sectionWithHeaderIndex = submenuIndex + 1; sectionWithHeaderIndex < submenu.length; sectionWithHeaderIndex++) {
                        if (submenu[sectionWithHeaderIndex].headerLabel === true) {
                            break;
                        }

                        submenuComponent.push(
                            <HbrMenuItem
                                shellNav
                                value={submenu[sectionWithHeaderIndex].text}
                                onClick={() => handleMenuClick({ path: `/#/${submenu[sectionWithHeaderIndex].sref?.replaceAll(".", "/")}`, submenu: [] }, isvManagePath)}
                                key={Math.random()}
                            >
                                {submenu[sectionWithHeaderIndex].text}
                            </HbrMenuItem>
                        )
                        submenuIndex++;
                    }

                    // append section with header to menu
                    if (submenu.length === submenuComponent.length)
                        MenuItemsComponent.push(
                            <HbrMenu shellNav key={Math.random()}>
                                {submenuComponent}
                            </HbrMenu>
                        );

                } else if (isHeaderLabelFound === false) {
                    let path = "/#/";
                    if (submenu[submenuIndex].type === "convergence") {
                        path = submenu[submenuIndex].url;
                    } else {
                        path = isvManagePath ?
                            `/#/${submenu[submenuIndex]?.sref?.replaceAll(".", "/")?.replaceAll("admin/", "administration/").replaceAll("configurationGroups", "configurationGroups/sdwan")}` :
                            `${submenu[submenuIndex]?.path}`;
                    }

                    let menuLabel = submenu[submenuIndex].text;
                    let isvAnalyticsPath = false;
                    const submenuText = submenu[submenuIndex]?.text?.toLowerCase();
                    let extraSubmenuAnalytics = false;

                    /**** Reports: Added for tick mark selection in reports menu ***/
                    let reportMenuSelection = false;
                    if (submenu[submenuIndex]?.feature === 'reports') {
                        var currMenuPath = submenu[submenuIndex]?.path.substring(path.indexOf('#') + 1);
                        var currUrlPath = window.location.hash.replace(/^#/, "");
                        if (currMenuPath === currUrlPath) {
                            reportMenuSelection = true;
                        }
                    }

                    if (isvManagePath) {
                        if (navItem.text === "Analytics" && submenuText === "overview" && !('tab' in navItem.submenu[0])) {
                            extraSubmenuAnalytics = true;
                            path = routeURLs.pn;
                            menuLabel = tGenerics('megaMenuPredictiveNetworks');
                            isvAnalyticsPath = true;
                        } else if (submenuText === "applications") {
                            path = routeURLs.applications;
                            isvAnalyticsPath = true;
                        } else if (submenuText === "internet outages") {
                            path = replace(path, "internetOutages", "internet-outages");
                            isvAnalyticsPath = false;
                        }
                    }

                    //check if the menu is checked or not
                    let isChecked = false;

                    /**** Menu : Tick mark selection in Application 360 page ***/
                    let app360PathName = location.pathname.includes("/Dashboards");
                    if (menuLabel.includes("Bandwidth Forecast") && isBandwidthForecastingTab) {
                        // Special case for Bandwidth Forecasting
                        isChecked = true;
                    } else if (location.pathname.includes("anomaly") && (menuLabel.includes("Predictive Networks") || menuLabel.includes("Bandwidth Forecast"))) {
                        // Special case for Anomaly Detection
                        isChecked = false;
                    } else if (menuLabel.includes("Bandwidth Forecast")) {
                        // Special case for Bandwidth Forecasting
                        isChecked = false;
                    } else if (reportMenuSelection === true) {
                        // Special case for Reports
                        isChecked = true;
                    } else if (menuLabel === 'Applications' && app360PathName) {
                        // Special case for Applications in Application 360 page
                        isChecked = true;
                    } else {
                        isChecked = (location.pathname.includes(menuLabel?.toLowerCase()?.replaceAll(" ", "")) && !isBandwidthForecastingTab)
                    }

                    submenuComponent.push(
                        <HbrMenuItem
                            shellNav
                            value={menuLabel}
                            checked={isChecked}
                            checkMark
                            onClick={(e) => handleMenuClick({ path: path, submenu: submenu[submenuIndex] }, isvManagePath, isvAnalyticsPath, e)}
                            key={Math.random()}
                            aria-current={isChecked ? "true" : undefined}
                        >
                            <div className="menu-label-wrapper">
                                {menuLabel}
                                {submenu[submenuIndex].beta === true && (
                                    <div slot="suffix" className="beta-wrapper"><BetaTag /></div>
                                )}
                            </div>
                        </HbrMenuItem>
                    )

                    if (extraSubmenuAnalytics) {
                        const submenus = ["Optimization", "Threat Intelligence"];
                        const paths = [routeURLs.optimization, routeURLs.threatIntelligence];

                        submenus.forEach((submenu, index) => {
                            submenuComponent.push(
                                <HbrMenuItem
                                    shellNav
                                    value={submenu}
                                    checked={location.pathname.includes(submenu.toLowerCase().replaceAll(" ", ""))}
                                    checkMark
                                    onClick={(e) => handleMenuClick({ path: paths[index], submenu: { url: paths[index] } }, true, true, e)}
                                    key={Math.random()}
                                    aria-current={submenu}
                                >
                                    {submenu}
                                </HbrMenuItem>
                            )
                        })
                    }

                    if (!('tab' in navItem.submenu[0])) {
                        //block below is for menu that is not dynamic, but rather hardcoded, and application, sites and circuits are hardcoded
                        //and placed in the end of tab group
                        if (isvManagePath && submenuText === "applications") {
                            const vaMenuArray = [tGenerics('megaMenuSitesLabel'), tGenerics('megaMenuCircuits')];
                            const vaMenuPaths = [routeURLs.sites, routeURLs.circuits];
                            isvAnalyticsPath = true;

                            vaMenuArray.forEach((element, index) => {
                                submenuComponent.push(
                                    <HbrMenuItem
                                        shellNav
                                        value={element}
                                        checked={location.pathname.includes(element.toLowerCase())}
                                        checkMark
                                        onClick={() => handleMenuClick({ path: vaMenuPaths[index], submenu: [] }, isvManagePath, isvAnalyticsPath)}
                                        key={Math.random()}
                                    >
                                        {element}
                                    </HbrMenuItem>
                                )
                            });
                        }
                    }//end of if isCookieMenuFound
                }
            }
            //submenu with no header sections
            if (isHeaderLabelFound === false) {
                MenuItemsComponent = (
                    <HbrMenu shellNav>
                        {submenuComponent}
                    </HbrMenu>)
            }
        }
    }

    const icon = getIconName(navItem.icon);
    const isSelected = navItem.text === "Analytics" && isAnalyticsPage() ||
        navItem.text === "Monitor" && !isAnalyticsPage() ||
        navItem.feature === "reports" && location.pathname?.includes(navItem.feature) ||
        navItem?.submenu?.find((item) => (item.path?.includes(location.pathname)));

    return (
        <HbrNavItem
            selected={isSelected}
            collapsed
            className="nav-item-section"
            onClick={isSingleMenuItem ? (event) => onClick(event) : null}
        >
            {navItem.icon === "people"
                ? <Administrator
                    slot="prefix"
                />
                : <HbrIcon
                    slot="prefix"
                    name={icon}
                />}
            {isSingleMenuItem === true
                ? <div slot="content">{navItem.text}</div>
                : <>
                    <div slot="content">
                        {navItem.text}
                    </div>
                    <div slot="drawerHeader">{navItem.text}</div>
                    <div slot="menu" className="sub-menu">
                        {MenuItemsComponent}
                    </div>
                </>
            }
        </HbrNavItem>
    )
}

Menu.propTypes = {
    navItem: PropTypes.object,
    onClick: PropTypes.func,
    isSingleMenuItem: PropTypes.bool,
    isCookieMenuFound: PropTypes.bool,
    setAltoProps: PropTypes.func
}

export default Menu;
